package fyi.moko.hotpl.ui.detail

import androidx.compose.runtime.Composable
import kotlinx.browser.window

actual fun buildOpenInMapsUrl(latitude: Double, longitude: Double, label: String?): String =
    "https://www.google.com/maps/search/?api=1&query=$latitude,$longitude"

@Composable
actual fun rememberOpenInMapsLauncher(): (latitude: Double, longitude: Double, label: String?) -> Boolean {
    return { latitude, longitude, label ->
        val url = buildOpenInMapsUrl(latitude, longitude, label)
        window.open(url, "_blank") != null
    }
}
